import { useEffect, useState } from 'react';

/**
 * La base de alimentos incluida se carga con import dinámico al abrir el
 * buscador (design.md, 11.2): no pesa en el arranque y, como es un módulo, el
 * Service Worker la precarga y funciona sin conexión.
 */
type ModuloBase = typeof import('@/datos/alimentos-base');

let promesa: Promise<ModuloBase> | null = null;

export function cargarAlimentosBase(): Promise<ModuloBase> {
  promesa ??= import('@/datos/alimentos-base').catch((error: unknown) => {
    promesa = null; // que el siguiente intento vuelva a probar
    throw error;
  });
  return promesa;
}

export type EstadoBase =
  | { estado: 'cargando' }
  | { estado: 'lista'; modulo: ModuloBase }
  | { estado: 'error' };

export function useAlimentosBase(): EstadoBase {
  const [base, setBase] = useState<EstadoBase>({ estado: 'cargando' });
  useEffect(() => {
    let vigente = true;
    cargarAlimentosBase().then(
      (modulo) => {
        if (vigente) setBase({ estado: 'lista', modulo });
      },
      () => {
        if (vigente) setBase({ estado: 'error' });
      },
    );
    return () => {
      vigente = false;
    };
  }, []);
  return base;
}
